import React from "react";
import Wallet from "../components/Wallet";

const WalletPage = ({}) => {
  return <Wallet />;
};

export default WalletPage;
